import { Layout, CheckDeviceState as CheckDeviceStateComponent } from "components"
export const CheckDeviceState = () => {
 return (
  <Layout>
   <CheckDeviceStateComponent />
  </Layout>
 )
}
